import { render } from "./ExtraKyrgyzLetters.vue?vue&type=template&id=8296335a"
import script from "./ExtraKyrgyzLetters.vue?vue&type=script&lang=js"
export * from "./ExtraKyrgyzLetters.vue?vue&type=script&lang=js"

import "./ExtraKyrgyzLetters.vue?vue&type=style&index=0&id=8296335a&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__